/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_itemSearch = {
    readonly pageType: string | null;
    readonly vanityUriRef: string | null;
    readonly displayUriRef: string | null;
    readonly " $refType": "SbSharedRefetchContainer_itemSearch";
};
export type SbSharedRefetchContainer_itemSearch$data = SbSharedRefetchContainer_itemSearch;
export type SbSharedRefetchContainer_itemSearch$key = {
    readonly " $data"?: SbSharedRefetchContainer_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefetchContainer_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vanityUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '56f0d134e98dd2feb516b4d2c51167d4';
export default node;
